import { adapter, useGetNotificationsQuery } from "./api"
import { NotificationType } from "./model"

export const useGetNotifications = () =>
  useGetNotificationsQuery(undefined, {
    selectFromResult: ({
      data: notifications,
      isLoading,
      isUninitialized,
    }) => ({
      notifications: notifications
        ? adapter.getSelectors().selectAll(notifications)
        : undefined,
      isLoading: isLoading || isUninitialized,
    }),
  })

const SETTLEMENT_TYPES = new Set<NotificationType>([
  NotificationType.SelfProfileReady,
  NotificationType.AssignmentsSent,
  NotificationType.CreditsReady,
])

/**
 * The settlement notification for a specific checkout, or undefined until it
 * arrives. A purchase dialog awaits this after triggering finalize: the
 * outcome is delivered over realtime, not returned by finalize, so the dialog
 * correlates the bell event to its own PaymentIntent by id. Reads the shared
 * notifications cache the bell already keeps live over Ably.
 */
export const useSettlementNotification = (paymentIntentId: string | null) =>
  useGetNotificationsQuery(undefined, {
    selectFromResult: ({ data }) => ({
      settlement:
        paymentIntentId && data
          ? adapter
              .getSelectors()
              .selectAll(data)
              .find(
                (notification) =>
                  SETTLEMENT_TYPES.has(notification.type) &&
                  notification.params?.paymentIntentId === paymentIntentId,
              )
          : undefined,
    }),
  })
